package com.essntl.features.authentication.data.data

import com.essntl.features.authentication.domain.models.CheckModel
import kotlinx.serialization.Serializable

@Serializable
data class CheckDto(
    val state: String,
) {
    fun toModel() =
        CheckModel(
            state = when (state) {
                "NO_TENANT_FOUND" -> CheckModel.State.NO_TENANT_FOUND
                "USER_NOT_FOUND" -> CheckModel.State.USER_NOT_FOUND
                "OTP_SENT" -> CheckModel.State.OTP_SENT
                else -> throw IllegalArgumentException("Unknown state: $state")
            },
        )
}